import { ca } from '@cian/analytics';
import { getFormId } from '../../../../browser/services/formId';

export const trackRequiredFieldFill = (category: string, label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'sopr_required_field_fill_in',
    label,
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: getFormId(),
      },
    },
  });
};
